import { render, staticRenderFns } from "./iconBoolean.vue?vue&type=template&id=fac7b74e&"
import script from "./iconBoolean.vue?vue&type=script&lang=js&"
export * from "./iconBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports